import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import localeText from "../../../locale";

const ReferralField = ({
  hasReferral,
  setHasReferral,
  referralUsername,
  setReferralUsername,
  referralIconSpinner,
  setReferralIconSpinner,
  referralRef,
  onBlurReferral,
  loading,
}) => {
  return (
    <div className="field">
      <div className="flex align-items-start gap-2">
        <Checkbox
          inputId="hasReferral"
          checked={hasReferral}
          onChange={(e) => {
            setHasReferral(e.checked);
            if (!e.checked) {
              setReferralUsername("");
              setReferralIconSpinner("");
            }
          }}
          disabled={loading}
        />
        <label htmlFor="hasReferral" className="text-sm" style={{ color: "#344563" }}>
          {localeText("iHaveReferral")}
        </label>
      </div>

      {hasReferral && (
        <>
          <label className="font-semibold text-sm mt-2" htmlFor="referral" style={{ color: "#0D0D0E" }}>
            {localeText("referralUsername")}
          </label>
          <span className="p-input-icon-right">
            <i className={referralIconSpinner} />
            <InputText
              ref={referralRef}
              name="referral"
              type="text"
              value={referralUsername}
              onChange={(e) => setReferralUsername(e.target.value)}
              disabled={loading}
              onBlur={onBlurReferral}
              onFocus={() => {
                setReferralIconSpinner("");
                if (referralRef.current) referralRef.current.style.border = "1px solid #ced4da";
              }}
              className="w-full p-3 mt-2"
              placeholder={localeText("enterReferralUsername")}
            />
          </span>
        </>
      )}
    </div>
  );
};

export default ReferralField;

